export const PUBLIC_CHAT_LAYOUT_STORAGE_KEY = "yaprio.public-chat.layout.v1";

export const DEFAULT_PUBLIC_CHAT_LAYOUT = {
  desktop: {
    headerHeight: 76,
    headerX: 16,
    headerY: 16,
    messagesX: 0,
    messagesY: 20,
    contentX: 16,
    contentY: 16,
    messageGap: 12,
    composerX: 12,
    composerY: 12,
    composerInnerX: 6,
    composerInnerY: 6,
    maxWidth: 1200,
  },
  mobile: {
    headerHeight: 76,
    headerX: 12,
    headerY: 12,
    messagesX: 0,
    messagesY: 12,
    contentX: 12,
    contentY: 8,
    messageGap: 10,
    composerX: 8,
    composerY: 8,
    composerInnerX: 4,
    composerInnerY: 4,
    maxWidth: 680,
  },
};

export function cloneDefaultPublicChatLayout() {
  return JSON.parse(JSON.stringify(DEFAULT_PUBLIC_CHAT_LAYOUT));
}

export function loadPublicChatLayout() {
  if (typeof window === "undefined") return cloneDefaultPublicChatLayout();
  try {
    const raw = window.localStorage.getItem(PUBLIC_CHAT_LAYOUT_STORAGE_KEY);
    if (!raw) return cloneDefaultPublicChatLayout();
    const saved = JSON.parse(raw);
    return {
      desktop: { ...DEFAULT_PUBLIC_CHAT_LAYOUT.desktop, ...(saved.desktop || {}) },
      mobile: { ...DEFAULT_PUBLIC_CHAT_LAYOUT.mobile, ...(saved.mobile || {}) },
    };
  } catch {
    return cloneDefaultPublicChatLayout();
  }
}

export function savePublicChatLayout(layout) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(PUBLIC_CHAT_LAYOUT_STORAGE_KEY, JSON.stringify(layout));
}
